import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 28,
    mass: 0.3,
  });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress-bar"
      className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-gradient-to-r from-[#3CBE6E] via-[#1C7543] to-[#B8912A]"
      style={{ scaleX }}
    />
  );
};
